// extracted by mini-css-extract-plugin
export default {"education-and-research__icon-container":"style_education-and-research__icon-container__xkWnI","education-and-research__text":"style_education-and-research__text__Q0yPL"};